import { RSAA, getJSON } from 'redux-api-middleware';
import qs from 'querystring';

import { getJWT } from '../authentication/utils';

import {
    SUBSCRIPTIONS_REQUEST,
    SUBSCRIPTIONS_SUCCESS,
    SUBSCRIPTIONS_FAILURE,
    SUBSCRIPTION_REQUEST,
    SUBSCRIPTION_SUCCESS,
    SUBSCRIPTION_FAILURE,
    SUBSCRIPTION_CANCEL_REQUEST,
    SUBSCRIPTION_CANCEL_SUCCESS,
    SUBSCRIPTION_CANCEL_FAILURE,
    UPDATE_SUBSCRIPTIONS,
    GET_SUBSCRIPTION_DELIVERY_REQUEST,
    GET_SUBSCRIPTION_DELIVERY_SUCCESS,
    GET_SUBSCRIPTION_DELIVERY_FAILURE,
} from './types';
import { CONTENT_TYPE_HEADER, CONTENT_TYPES } from '../../constants/http';

export const fetchSubscriptions = () => ({
    [RSAA]: {
        endpoint: `${CONFIG.myPage.apiHost}/subscriptions?${qs.stringify({ filters: 'active' })}`,
        method: 'GET',
        headers: {
            Authorization: getJWT(),
            Publisher: CONFIG.myPage.publication,
            'X-Frontend-Version': process.env.FRONTEND_VERSION_HASH || '',
            'X-Frontend-Build-Time': process.env.FRONTEND_BUILD_TIMESTAMP || '',
        },
        types: [
            SUBSCRIPTIONS_REQUEST,
            SUBSCRIPTIONS_SUCCESS,
            SUBSCRIPTIONS_FAILURE,
        ],
    },
});

export const fetchSubscription = ({ subscriptionId }) => ({
    [RSAA]: {
        endpoint: `${CONFIG.myPage.apiHost}/subscriptions/${subscriptionId}`,
        method: 'GET',
        headers: {
            Authorization: getJWT(),
            Publisher: CONFIG.myPage.publication,
            'X-Frontend-Version': process.env.FRONTEND_VERSION_HASH || '',
            'X-Frontend-Build-Time': process.env.FRONTEND_BUILD_TIMESTAMP || '',
        },
        types: [
            {
                type: SUBSCRIPTION_REQUEST,
                payload: { subscriptionId },
            },
            SUBSCRIPTION_SUCCESS,
            SUBSCRIPTION_FAILURE,
        ],
    },
});

export const cancelSubscription = (endpoint, subscriptionSource, reason, reactivateFromId) => ({
    [RSAA]: {
        endpoint,
        body: JSON.stringify({
            subscriptionSource,
            ...(reason ? { reason } : {}),
            ...(reactivateFromId ? { reactivateFromId } : {}),
        }),
        method: 'POST',
        headers: {
            Authorization: getJWT(),
            Publisher: CONFIG.myPage.publication,
            [CONTENT_TYPE_HEADER]: CONTENT_TYPES.JSON,
            'X-Frontend-Version': process.env.FRONTEND_VERSION_HASH || '',
            'X-Frontend-Build-Time': process.env.FRONTEND_BUILD_TIMESTAMP || '',
        },
        types: [
            SUBSCRIPTION_CANCEL_REQUEST,
            SUBSCRIPTION_CANCEL_SUCCESS,
            SUBSCRIPTION_CANCEL_FAILURE,
        ],
    },
});

export const updateSubscriptions = subscriptions => ({
    type: UPDATE_SUBSCRIPTIONS,
    payload: subscriptions,
});

export const fetchSubscriptionDelivery = ({ subscriptionId }) => ({
    [RSAA]: {
        endpoint: `${CONFIG.myPage.apiHost}/subscriptions/${subscriptionId}/deliveries`,
        method: 'GET',
        headers: {
            Authorization: getJWT(),
            Publisher: CONFIG.myPage.publication,
            'X-Frontend-Version': process.env.FRONTEND_VERSION_HASH || '',
            'X-Frontend-Build-Time': process.env.FRONTEND_BUILD_TIMESTAMP || '',
        },
        types: [
            {
                type: GET_SUBSCRIPTION_DELIVERY_REQUEST,
                payload: { subscriptionId },
            },
            {
                type: GET_SUBSCRIPTION_DELIVERY_SUCCESS,
                payload: (action, state, res) => getJSON(res).then(data => ({
                    subscriptionId,
                    data,
                })),
            },
            {
                type: GET_SUBSCRIPTION_DELIVERY_FAILURE,
                meta: { subscriptionId },
            },
        ],
    },
});
